import Formatter from 'shared/utils/formatters'
import ChangeGestorRequest from '../entities/ChangeGestorRequest'
import ChangeGestorResponse from '../entities/ChangeGestorResponse'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IChangeGestor {
  execute(params: ChangeGestorRequest): Promise<ChangeGestorResponse>
}

export default class ChangeGestorImpl implements IChangeGestor {
  constructor(private readonly userRepository: IUserRepository) {}

  private validateValuesChangeGestor(params: ChangeGestorRequest): string {
    const erros: string[] = []

    if (!params.email) {
      erros.push('Email')
    }
    if (!params.telefone) {
      erros.push('Telefone')
    }
    if (!params.doc_imagem_frente || !params.doc_imagem_verso) {
      erros.push('Foto do documento')
    }

    if (!params.senha) {
      erros.push('Senha')
    }

    if (erros.length) {
      let errorMessage = ''

      if (erros.length > 1) {
        errorMessage = 'Os campos obrigatórios estão faltando: '
        errorMessage =
          errorMessage + erros.slice(0, -1).join(', ') + ' e ' + erros.slice(-1)
      } else {
        errorMessage =
          'O campo obrigatório está faltando: ' +
          errorMessage +
          erros.map(String)
      }

      return errorMessage
    }
  }

  public formatarDadosParams(params: ChangeGestorRequest): ChangeGestorRequest {
    return {
      ...params,
      telefone: params.telefone.replace(Formatter.somenteNumeros(), ''),
    }
  }

  public async execute(
    params: ChangeGestorRequest,
  ): Promise<ChangeGestorResponse> {
    const errorMessage = this.validateValuesChangeGestor(params)

    if (errorMessage) {
      throw new Error(errorMessage)
    }

    const response = await this.userRepository.changeGestor(
      this.formatarDadosParams(params),
    )

    return response
  }
}
